import {constants} from "../constants";

export const environment = {
  production: false,
  name: constants.DEMO_EDU,
  env: "Stage",
  appBaseUrl: "",
  standaloneAppBaseUrl: "https://chromeos-selector-demo-edu-stg.web.app/",
  productInfoPageBaseUrl: "",
  firebaseConfigParam: "demo_education_config",
  notYourIndustryLinkUrl: "",
  firebaseUserEmail: "firebase-adminsdk-wh1m8@chromebook-selector-nsit-stage.iam.gserviceaccount.com",
  firebase: {
    apiKey: "AIzaSyAFNWx7PQS72H_1nozDFj93fd7AyFqB0hw",
    authDomain: "chromebook-selector-nsit-stage.firebaseapp.com",
    projectId: "chromebook-selector-nsit-stage",
    storageBucket: "chromebook-selector-nsit-stage.appspot.com",
    messagingSenderId: "920708053188",
    appId: "1:920708053188:web:a290626a29f0f16a387191",
    measurementId: "G-21JQFZDDMT"
  }
};
